import styled from 'styled-components'
import { useCallback, useRef } from 'react'

import { RecommendedVaults } from './RecommendedVault'
import { NeedHelpSection } from './NeedHelpSection'
import { BuildBySection } from './BuildBySection'
import { TitleMetricsSection } from './TitleMetricsSection'
import { AllVaults } from './AllVaults'
import { HEADER_ID } from 'components/Header/Header'

const Page = styled.div`
  min-height: calc(100vh - 110px);

  @media screen and (min-width: ${p => p.theme.breakpoints.md}px) {
    width: 100%;
    margin: auto;
  }
`

export const LandingPage = () => {
  const needHelpRef = useRef<HTMLTableElement>(null)

  const handleHowToConnectClick = useCallback(() => {
    if (needHelpRef.current) {
      const elementRect = needHelpRef.current.getBoundingClientRect()
      const scrollY = window.scrollY

      const headerElement = document.getElementById(HEADER_ID)
      const fixedHeaderHeight = headerElement ? headerElement.offsetHeight : 0

      window.scrollTo({
        top: scrollY + elementRect.top - fixedHeaderHeight,
        behavior: 'smooth',
      })
    }
  }, [])

  return (
    <Page>
      <TitleMetricsSection onHowToConnectClick={handleHowToConnectClick} />
      <BuildBySection />
      <RecommendedVaults />
      <AllVaults />
      <NeedHelpSection ref={needHelpRef} />
    </Page>
  )
}
